<p-panel header="Metrics" [toggleable]="true" class="validation-row">
  <ng-template pTemplate="icons">
    <label
      class="p-panel-header-icon"
      pTooltip="Specify metrics to calculate. Basic metrics between data set pairs are always calculated."
      tooltipPosition="bottom"
    >
      <span class="pi pi-question-circle"></span>
    </label>
  </ng-template>

  <div class="grid pt-3">
    <div class="col-12">
      <div class="flex flex-row align-items-center gap-2">
        <p-floatLabel class="flex-1">
          <p-select
            id="valTypeSelector"
            [options]="valTypeOptions"
            [(ngModel)]="validationModel().valType"
            optionLabel="label"
            optionValue="value"
            [disabled]="ISMN_isTrue()"
            [style]="{ width: '100%' }"
          >
          </p-select>
          <label for="valTypeSelector">Validation type</label>
        </p-floatLabel>
        <label
          class="p-panel-header-icon"
          pTooltip="Spatial validation is only available when ISMN is selected as a dataset"
          tooltipPosition="bottom"
        >
          <span class="pi pi-question-circle"></span>
        </label>
      </div>
    </div>

    @for (metric of validationModel().metrics; track metric) {
      <div class="col-12">
        <qa-metric
          [metricModel]="metric"
          [disabled]="checkIfDisabled(metric)"
        />
      </div>
    }

    <div class="col-12">
      <qa-intra-annual-metrics
        [(selectedMetric)]="validationModel().intraAnnualMetrics"
        [disabled]="intraAnnulMetricDisabled()"
      />
    </div>
  </div>
</p-panel>
